import React from 'react';
import StockStatusComponent from 'content/StockStatus';

const StockStatusBlock = () => <StockStatusComponent />;

export default StockStatusBlock;
